/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit EmailAddress/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function EmailAddress({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/New/Content/Email/Fields/EmailAddress",
  isInvalid,
  onChange
  
}) {
let newProfessionalEmailAddressValueData = fromData.useDataValue({ viewPath,
context: 'new_professional',
path: 'email.address',
})
let newProfessionalEmailAddressIsValidData = fromData.useDataIsValid({ viewPath,
context: 'new_professional',
path: 'email.address',
validate: fromValidate.email,
})
let newProfessionalEmailAddressChangeData = fromData.useDataChange({ viewPath,
context: 'new_professional',
path: 'email.address',
})
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 marginRight={dtSpaceS}
 data="new_professional.email.address"
 validate="/Data/validate.js email"
 invalid={!newProfessionalEmailAddressIsValidData}
 value={newProfessionalEmailAddressValueData}
 onChange={newProfessionalEmailAddressChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}